import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import { addInventoryInverter, updateInventoryInverter } from '../../../redux/api/inventoryApi/InventoryInvertorApi.js';
import { addInventoryInvertorAction, updateInventoryInvertorAction } from '../../../redux/reduxSlice/InventoryInvertorSlice.js';
import { fileUpload } from '../../../redux/api/surveyApi/SurveyApi.js';
import { X } from "lucide-react";
import './Inventory.css';
import Select from "react-select";

import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Img
} from '@chakra-ui/react';

function InvertorForm(props) {
  const {
    isUpdateMode,
    dataToEdit,
    formData: initialFormData,
    setIsUpdateMode,
    inventoryROWID,
    onNewDataAdded,
    closeDrawer,
    isDrawerOpen,
    sitesId,
    callback
  } = props;

  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [brand, setBrand] = useState([]);
  const [panel, setPanel] = useState([]);
  const brandList = useSelector((state) => state.utils.brandList);
  const solarbrandData = useSelector((state) => state.utils.solarList);
  const getInverterList = useSelector((state) => state.utils.getInverterList);
  const [inventoryInvertorAttachment, setInventoryInvertorAttachment] = useState([]);


  console.log("getInverterList", getInverterList)

  console.log("solarbrandData", solarbrandData)
  console.log("brandList", brandList)

  const brandData = useMemo(() => {
    return brandList.map((item) => ({
      label: item.solarBrandName,
      value: item.ROWID,
    }));
  }, [JSON.stringify(brandList)]);
  console.log("brandData", brandData)

  useEffect(() => {
    setBrand(brandData);
  }, [brandData])


  const panelData = useMemo(() => {
    return getInverterList.map((item) => ({
      label: item.inverterName,
      value: item.ROWID,
    }));
  }, [JSON.stringify(getInverterList)]);
  console.log("panelData", panelData)

  useEffect(() => {
    setPanel(panelData);
  }, [panelData])




  const [formData, setFormData] = useState({
    type: false,
    name: "",
    brandName: null,
    invertorType: null,
    KW: null,
    sellingPrice: null,
    purchasePrice: null,
    description: "",
    asStockInHand: null,
    asCommitedStock: null,
    asAvailableForSale: null,
    psStockInHand: null,
    psCommitedStock: null,
    asAvailableForSale: null,
  });

  const handleOnClose = () => {
    closeDrawer();
    setIsUpdateMode(false);
    setFormData({
      type: false,
      name: "",
      brandName: null,
      invertorType: null,
      KW: null,
      sellingPrice: null,
      purchasePrice: null,
      description: "",
      asStockInHand: null,
      asCommitedStock: null,
      asAvailableForSale: null,
      psStockInHand: null,
      psCommitedStock: null,
      asAvailableForSale: null,
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowProgressBar(true);

    try {
      // Upload all selected files
      const uploadResults = await Promise.all(
        selectedFiles.map(async (file) => {
          const formData = {
            attachment: file,
            folderName: "attachmentsbucket",
          };
          try {
            const response = await fileUpload(formData);
            if (response.data.success) {
              return response.data.response[0][0]; // Return uploaded file data
            }
          } catch (error) {
            console.error("Upload failed for", file.name, error);
            return null;
          }
        })
      );

      // Filter out successful uploads
      const successfulUploads = uploadResults.filter(Boolean);

      // Prepare payload with uploaded files
      const payload = {
        ...formData,
        inventoryInvertorAttachment: successfulUploads,
        createdBy: localStorage.getItem("email"),
      };

      // Submit form data
      const response = await addInventoryInverter(payload);
      if (response.data.success) {
        const ROWID = response.data.response.ROWID;
        dispatch(addInventoryInvertorAction({ ROWID, formData }));
        // Reset form and selected files
        // setFormData({ /* ...initial state */ });
        setFormData({
          type: false,
          name: "",
          brandName: null,
          invertorType: null,
          KW: null,
          sellingPrice: null,
          purchasePrice: null,
          description: "",
          asStockInHand: null,
          asCommitedStock: null,
          asAvailableForSale: null,
          psStockInHand: null,
          psCommitedStock: null,
          psAvailableForSale: null,
        });
        setSelectedFiles([]);
        toast.success("Invertor added successfully!");
        onNewDataAdded();
        handleOnClose();
      } else {
        toast.error("Unable to add Invertor, Please try again!");
      }
    } catch (error) {
      console.error("API Error", error);
      toast.error("Failed to add Invertor. Please try again.");
    } finally {
      setShowProgressBar(false);
      if (typeof callback === 'function') {
        callback();
      }
    }
  };





  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...dataToEdit,
      }));
    }
  }, [isUpdateMode, dataToEdit]);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  const handelOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    updateInventoryInverter(formData).then((response) => {
      if (response.data.success) {
        setFormData((prev) => ({
          ...prev, ROWID: response?.data.ROWID
        }));
        dispatch(updateInventoryInvertorAction(formData));
        toast.success("Invertor Updated Successfully!!");
      }
      setTimeout(() => {
        handleOnClose();
        setShowProgressBar(false);
        setSubmitDisabled(false);
      }, 300);
    }).catch((error) => {
      toast.error("Invertor Update Failed!");
      setShowProgressBar(false);
    }).finally(() => {
      setSubmitDisabled(false);
    });
  };


  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // If changing 'type', set it as a boolean instead of a string
    const newValue = name === "type" ? value === "goods" : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };


  // custom style for lookup
  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? "silver" : "rgb(93, 135, 255)",
      borderRadius: "10px",
      border: "0.5px solid rgb(196,196,196,0.5) !important",
    }),

    placeholder: (styles) => ({
      ...styles,
      color: "gray",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color: "black",
      backgroundColor: "white",
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected
        ? "#f1e9e9;"
        : isFocused
          ? "#f1e9e9;"
          : "white",
      color: isSelected ? "#666" : "#333",
    }),
  };

  const itemComponent = {
    MenuList: (props) => (
      <div style={{ position: 'relative' }}>
        <div {...props.innerProps} className="custom-menu-list"
          style={{
            maxHeight: '190px',
            overflowY: 'auto',
            paddingBottom: '40px',
            zIndex: 9999,
          }}>
          {props.children}
        </div>
      </div>
    ),
  };


  const [fileName, setFileName] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };



  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 25 * 1024 * 1024; // 25 MB
    const maxFiles = 5;

    if (files.length === 0) return;

    // Calculate remaining slots
    const remainingSlots = maxFiles - selectedFiles.length;
    if (remainingSlots <= 0) {
      toast.error("You can only upload up to 5 files");
      e.target.value = null; // Reset input
      return;
    }

    // Slice and filter valid files
    const validFiles = files.slice(0, remainingSlots).filter((file) => {
      if (file.size > maxSize) {
        alert(`${file.name} exceeds the 25 MB limit and will not be uploaded.`);
        return false;
      }
      return true;
    });

    // Update selected files state
    setSelectedFiles((prev) => [...prev, ...validFiles]);
    e.target.value = null; // Reset input to allow re-upload
  };


  const removeinventoryInvertorAttachment = (index) => {
    setInventoryInvertorAttachment((prevAttachments) => prevAttachments.filter((_, i) => i !== index));
  };


  return (
    <>
      <Drawer
        isOpen={isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{isUpdateMode ? "Update Invertor Form" : "Create Invertor Form"}</DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme='pink' />}
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>

              <div className="card" style={{ marginTop: '20px' }}>
                <div className="card-body">
                  <div className='row justify-content-center '>


                    <div className="row justify-content-center">
                      <div className="col-lg-12 mb-2 mt-2">
                        <div className="d-flex gap-3 flex-wrap">
                          {selectedFiles.map((file, index) => (
                            <div key={index} className="position-relative border p-2 rounded bg-light">
                              <span className="position-relative">
                                {file.name}
                                <span style={{ cursor: "pointer" }} data-bs-toggle="tooltip" data-bs-title="Remove file" className="position-absolute top-0 start-100 translate-middle badge">
                                  <X size={14} color="red" onClick={() => setSelectedFiles(index)} />
                                </span>
                              </span>
                            </div>
                          ))}
                        </div>
                        <label
                          htmlFor="imageUploadattachement"
                          className="image-upload card mt-2"
                          style={{
                            border: "2px dashed lightgrey",
                            borderRadius: "10px",
                            width: "100%",
                            height: "100px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div className="w-25 mx-auto">
                            <input className="form-control" type="file" id="imageUpload" name="inventoryInvertorAttachment" onChange={(e) => handleFileUpload(e, "inventoryInvertorAttachment")} multiple />
                            <div
                              className="image-upload-content"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <i className="fas fa-cloud-upload-alt" style={{ fontSize: "24px", marginBottom: "5px" }}></i>
                            </div>
                          </div>
                        </label>
                        <FormLabel className="small-label ps-3">Additional attachments</FormLabel>
                      </div>
                    </div>

                  </div>

                  <div className='row mt-4'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Name' name='name' value={formData?.name} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Name</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Product Code' name='productCode' value={formData?.productCode} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Product Code</FormLabel>
                    </div>
                  </div>

                  <div className='row'>
                    {/* <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <Select
                        name="brandName"
                        options={brandData}
                        defaultValue={brandData && brandData?.find((item) => item.value === formData?.brandName)}
                        onChange={(option) => {
                          setFormData((prevFormData) => ({ ...prevFormData, brandName: option.value }));
                        }}
                        styles={{
                          ...customStyle,
                          menu: (provided) => ({ ...provided, maxHeight: 300, zIndex: 9999 }),
                        }}
                        components={itemComponent}
                      />

                      <FormLabel className="small-label ps-3">Brand Name</FormLabel>
                    </div> */}
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>

                      <Select
                        name="invertorType"
                        options={panelData}
                        defaultValue={panelData && panelData?.find((item) => item.value === formData?.invertorType)}
                        onChange={(option) => {
                          setFormData((prevFormData) => ({ ...prevFormData, invertorType: option.value }));
                        }}
                        styles={{
                          ...customStyle,
                          menu: (provided) => ({ ...provided, maxHeight: 300, zIndex: 9999 }),
                        }}
                        components={itemComponent}
                      />


                      <FormLabel className="small-label ps-3">Invertor Type</FormLabel>
                    </div>

                     <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='KW' name='KW' value={formData?.KW} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">KW</FormLabel>
                    </div>

                  </div>


                  {/* <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='KW' name='KW' value={formData?.KW} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">KW</FormLabel>
                    </div>
                  </div> */}



                </div>
              </div>

              <div className="card" style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div className="card-body">
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Selling Price' name='sellingPrice' value={formData?.sellingPrice} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Selling Price </FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Purchase Price' name='purchasePrice' value={formData?.purchasePrice} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Purchase Price </FormLabel>
                    </div>

                  </div>


                </div>
              </div>

              <div className='row '>
                <div className='col-lg-12 col-md-6 col-sm-12 mb-2'>
                  <textarea className='form-control rounded' rows='4' placeholder='Description' name='description' value={formData?.description} onChange={handleChange} >
                  </textarea>
                  <FormLabel className="small-label ps-3">Description </FormLabel>
                </div>
              </div>

              <div className="card" style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div className="card-body">
                  <h6 className="card-title">Accounting Stock</h6>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Stock in Hand' name='asStockInHand' value={formData?.asStockInHand} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Stock in Hand</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Commited Stock' name='asCommitedStock' value={formData?.asCommitedStock} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Commited Stock</FormLabel>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Available for Sale' name='asAvailableForSale' value={formData?.asAvailableForSale} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Available for Sale</FormLabel>
                    </div>
                  </div>

                </div>

              </div>

              <div className="card" style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div className="card-body">
                  <h6 className="card-title">Physical Stock</h6>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Stock in Hand' name='psStockInHand' value={formData?.psStockInHand} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Stock in Hand</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Commited Stock' name='psCommitedStock' value={formData?.psCommitedStock} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Commited Stock</FormLabel>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Available for Sale' name='psAvailableForSale' value={formData?.psAvailableForSale} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Available for Sale</FormLabel>
                    </div>
                  </div>

                </div>

              </div>
            </form>
          </DrawerBody>
          <center>
            <DrawerFooter style={{ display: 'inline-block' }}>
              <div className='gap-3 d-flex'>
                <button variant='outline' className='cancel-button' mr={3} onClick={handleOnClose}>
                  Cancel
                </button>
                <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} >
                  {isUpdateMode ? "Update" : "Submit"}
                </button>
              </div>
            </DrawerFooter>
          </center>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default InvertorForm;


